import { ApolloClient } from '@apollo/client';
import { get } from 'lodash';
import logger from '../common/helpers/logger/logger';
import { getVideoTypes } from '../common/helpers/domain/videoTypes';
import { VIDEO_RECOMMENDATION_QUERY } from '../queries/contentPage/videoRecommendation';

interface FetchRecommendedVideosOptions {
  articleId?: number;
  id?: number;
}
export const fetchRecommendedVideos = async (
  client: ApolloClient<unknown>,
  options: FetchRecommendedVideosOptions,
) => {
  try {
    logger.logInfo('videoServices.fetchRecommendedVideos', 'Begin', options);

    const variables = {
      id: options.articleId,
      videoType: getVideoTypes(),
    };

    const response = await client.query({
      query: VIDEO_RECOMMENDATION_QUERY,
      variables: variables,
    });
    return get(response, 'data', {});
  } catch (error) {
    logger.logError(
      'videoService.fetchRecommendedVideos',
      'Error retrieving from query.',
      {
        options,
        error,
      },
    );
    throw error;
  }
};
